import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { PASSPORTS_LIST_ROUTES as ROUTES } from './utils'
import { lkPassportPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_PASSPORTS_LIST } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'passport',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "passport-templates.store" */
        './store'
      )
      registerModule(options)
      const { registerModule: handbookRegisterModule } = await import(
        /* webpackChunkName: "form-handbook.store" */
        '@/views/FormsHandbook/store/cache'
      )
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'view-passport-pages-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "passport-templates.list" */
          './PassportTemplatesList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "publications.view" */
          './PassportView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
